import React from 'react'
import { Grid, GridProps } from '@mui/material'
import { StorageSoftwareVersion } from 'src/Libs/wallboxes/types'
import { isVersionGreaterThanOrEqualTo } from 'src/Libs/wallboxes/utils'
import useActiveInstallationContext from 'src/Libs/installations/hooks/use-active-installation-context'

interface Props extends GridProps {
  children: React.ReactNode
}

/**
 * Display grid item for Wallbox settings form
 */
const WallboxSettingsFormGridItem: React.FC<Props> = ({ children }) => {
  const { storage } = useActiveInstallationContext()
  const softwareVersion = storage?.softwareRelease
  const isNewLayout = softwareVersion ? isVersionGreaterThanOrEqualTo(softwareVersion, StorageSoftwareVersion.X_2024_04) : false

  return (
    <Grid item xs={12} md={isNewLayout ? 12 : 6}>
      {children}
    </Grid>
  )
}

export default WallboxSettingsFormGridItem
